exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#clients-header[data-v-77326734]{background-image:url(\"/../img/Fondo_Clientes.png\")}#clients-content[data-v-77326734],#clients-header[data-v-77326734]{padding-top:10rem;padding-bottom:calc(10rem - 56px);background-position:50%;background-repeat:no-repeat;background-size:cover}#clients-content[data-v-77326734]{background-image:url(\"/../img/Fondo_Clientes_Blanco.png\")}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-77326734","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/vue/components/clients/Clients.vue
// module id = 6U33
// module chunks = 0